import React, { useState } from "react";
import Navbar, { ScrollIndicator } from "./Navbar";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";

const IMAGES = {
  heroBg: "/images/imageweb_1.jpg",
  staff1: "/images/staff-1.jpg",
  staff2: "/images/staff-2.jpg",
  staff3: "/images/staff-3.jpg",
};
const MAP_EMBED_URL =
  "https://www.google.com/maps?cid=5313368473858328249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAEYASAB&hl=en&gl=ID&source=embed&output=embed";

const CONTACT_PERSONS = [
  {
    name: "Staff 1",
    role: "Informasi Umum & Kerjasama",
    phone: "+62 812-XXXX-XXXX",
    img: IMAGES.staff1,
  },
  {
    name: "Staff 2",
    role: "Operasional & Program",
    phone: "+62 812-XXXX-XXXX",
    img: IMAGES.staff2,
  },
  {
    name: "Staff 3",
    role: "Keuangan & Administrasi",
    phone: "+62 812-XXXX-XXXX",
    img: IMAGES.staff3,
  },
];

export default function Contact({ isAdmin, AdminSection }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [sent, setSent] = useState(false);

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Nama wajib diisi";
    if (!form.email.trim() || !/\S+@\S+\.\S+/.test(form.email))
      e.email = "Email tidak valid";
    if (!form.subject.trim()) e.subject = "Subjek wajib diisi";
    if (!form.message.trim()) e.message = "Pesan wajib diisi";
    return e;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }
    setErrors({});
    setSent(true);
  };

  const inputCls = (field) =>
    `w-full border px-4 py-2.5 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#3d4f45] transition ${
      errors[field] ? "border-red-400 bg-red-50" : "border-gray-200 bg-white"
    }`;

  return (
    <div className="min-h-screen bg-white font-serif page-transition">
      <style>{`
        .page-hero { height:420px; min-height:320px; position:relative; display:flex; align-items:center; justify-content:center; background-size:cover; background-position:center; overflow:hidden; }
        .page-hero-overlay { position:absolute; inset:0; background:linear-gradient(160deg,rgba(20,40,28,0.75) 0%,rgba(61,79,69,0.52) 60%,rgba(15,30,20,0.82) 100%); }
        .page-hero-content { position:relative; z-index:10; text-align:center; padding:64px 1.5rem 0; animation:pgFadeUp 0.9s ease 0.15s both; }
        @keyframes pgFadeUp { from{opacity:0;transform:translateY(24px)} to{opacity:1;transform:translateY(0)} }
      `}</style>
      <Navbar />
      <WhatsAppButton />

      {/* HERO */}
      <section
        className="page-hero"
        style={{ backgroundImage: `url(${IMAGES.heroBg})` }}
      >
        <div className="page-hero-overlay" />
        <div className="page-hero-content">
          <p
            style={{
              fontSize: ".62rem",
              letterSpacing: ".32em",
              color: "#b8c5ba",
              textTransform: "uppercase",
              marginBottom: "1rem",
            }}
          >
            BUM Desa Warga Dekat Bandung
          </p>
          <h1
            style={{
              fontSize: "clamp(2rem,4.5vw,3.4rem)",
              color: "#fff",
              fontWeight: 300,
              lineHeight: 1.18,
              marginBottom: "1rem",
            }}
          >
            Hubungi Kami
          </h1>
          <p
            style={{
              fontSize: ".87rem",
              color: "rgba(255,255,255,.82)",
              maxWidth: "520px",
              margin: "0 auto",
              lineHeight: 1.75,
            }}
          >
            Ada pertanyaan, ide kerjasama, atau ingin memesan produk? Tim kami
            siap membantu.
          </p>
        </div>
        <ScrollIndicator targetId="contact-section" />
      </section>

      {/* CONTACT */}
      <section id="contact-section" className="py-24 px-6 bg-white">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16">
          {/* FORM */}
          <div>
            <h2 className="text-3xl mb-2 text-[#3d4f45] font-light">
              Kirim Pesan
            </h2>
            <p className="text-gray-500 mb-8 text-sm leading-relaxed">
              Isi formulir di bawah ini dan tim kami akan merespons dalam 1×24
              jam kerja.
            </p>
            {sent ? (
              <div className="bg-green-50 border border-green-200 rounded-xl p-8 text-center">
                <div className="text-4xl mb-3">✅</div>
                <h3 className="text-[#3d4f45] font-semibold text-lg mb-2">
                  Pesan Terkirim!
                </h3>
                <p className="text-gray-500 text-sm">
                  Terima kasih telah menghubungi kami. Kami akan merespons pesan
                  Anda segera.
                </p>
                <button
                  onClick={() => setSent(false)}
                  className="mt-5 text-xs text-[#3d4f45] underline"
                >
                  Kirim pesan lain
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-sm mb-1.5 text-gray-700 font-medium">
                    Nama Lengkap
                  </label>
                  <input
                    type="text"
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    placeholder="Masukkan nama lengkap Anda"
                    className={inputCls("name")}
                  />
                  {errors.name && (
                    <p className="text-red-500 text-xs mt-1">{errors.name}</p>
                  )}
                </div>
                <div>
                  <label className="block text-sm mb-1.5 text-gray-700 font-medium">
                    Email{" "}
                    {errors.email && (
                      <span className="text-red-500 font-normal ml-2">
                        {errors.email}
                      </span>
                    )}
                  </label>
                  <input
                    type="text"
                    value={form.email}
                    onChange={(e) =>
                      setForm({ ...form, email: e.target.value })
                    }
                    placeholder="nama@email.com"
                    className={inputCls("email")}
                  />
                </div>
                <div>
                  <label className="block text-sm mb-1.5 text-gray-700 font-medium">
                    Subjek
                  </label>
                  <input
                    type="text"
                    value={form.subject}
                    onChange={(e) =>
                      setForm({ ...form, subject: e.target.value })
                    }
                    placeholder="Topik pesan Anda"
                    className={inputCls("subject")}
                  />
                  {errors.subject && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.subject}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block text-sm mb-1.5 text-gray-700 font-medium">
                    Pesan
                  </label>
                  <textarea
                    value={form.message}
                    onChange={(e) =>
                      setForm({ ...form, message: e.target.value })
                    }
                    rows={6}
                    placeholder="Tulis pesan Anda di sini..."
                    className={inputCls("message")}
                  />
                  {errors.message && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.message}
                    </p>
                  )}
                </div>
                <button
                  type="submit"
                  className="bg-[#3d4f45] text-white px-8 py-3 rounded-full text-xs tracking-widest hover:bg-[#4a5a50] transition"
                >
                  KIRIM PESAN
                </button>
              </form>
            )}
          </div>

          {/* INFO */}
          <div>
            <h2 className="text-3xl mb-6 text-[#3d4f45] font-light">
              Informasi Kontak
            </h2>
            <div className="space-y-4 mb-8">
              {CONTACT_PERSONS.map((c, i) => (
                <div
                  key={i}
                  className="flex items-center gap-4 p-4 border border-gray-100 rounded-xl hover:shadow-sm transition"
                >
                  <div className="w-12 h-12 rounded-full overflow-hidden bg-[#b8c5ba] flex-shrink-0">
                    <img
                      src={c.img}
                      alt={c.name}
                      className="w-full h-full object-cover"
                      onError={(e) => (e.target.style.display = "none")}
                    />
                  </div>
                  <div>
                    <p className="font-semibold text-[#3d4f45] text-sm">
                      {c.name}
                    </p>
                    <p className="text-xs text-gray-500">{c.role}</p>
                    <p className="text-xs text-gray-600 mt-0.5">{c.phone}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-2 gap-6 mb-8">
              <div>
                <h3 className="font-semibold mb-2 text-[#3d4f45] text-sm">
                  Email
                </h3>
                <p className="text-gray-600 text-sm">info@bumdesa-puhu.id</p>
                <p className="text-gray-600 text-sm">bumdeswadet@gmail.com</p>
              </div>
              <div>
                <h3 className="font-semibold mb-2 text-[#3d4f45] text-sm">
                  Jam Operasional
                </h3>
                <p className="text-gray-600 text-xs leading-relaxed">
                  Senin – Kamis: 08.00 – 16.00
                  <br />
                  Jumat: 08.00 – 11.30
                  <br />
                  Sabtu: 08.00 – 14.00
                  <br />
                  Minggu: Tutup
                </p>
              </div>
            </div>

            <div>
              <h3 className="font-semibold mb-2 text-[#3d4f45] text-sm">
                Alamat
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Bukit Sinyonya
                <br />
                Batulingga, Bandung
                <br />
                Kec. Banjar, Kabupaten Pandeglang, Banten
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* MAP */}
      <section className="py-12 px-6 bg-[#f5f7f6]">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl text-center mb-8 text-[#3d4f45] font-light">
            Lokasi Kami
          </h2>
          <div
            className="rounded-2xl overflow-hidden shadow-md"
            style={{ height: "400px" }}
          >
            <iframe
              src={MAP_EMBED_URL}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Lokasi BUM Desa Warga Dekat Bandung"
            />
          </div>
        </div>
      </section>

      {isAdmin && (
        <div className="max-w-6xl mx-auto px-6 pb-8">
          <hr className="my-8 border-gray-200" />
          <AdminSection />
        </div>
      )}
      <Footer />
    </div>
  );
}
